// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__2stQg","soul":"style_soul__t4Pky","sticky":"style_sticky__uWC4N","contact":"style_contact__xk89N","language":"style_language__80Qt9","text":"style_text__7noxc"};